import styled from 'styled-components';
import { s } from './VIPReport.style';
import { IReportData } from '../../../service/quant/Quant';
import { useEffect, useRef, useState } from 'react';

const BasicInformation = ({ data }: { data?: IReportData['info'] }) => {
  const [showTootip, setShowTootip] = useState(false);

  const tooltipRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!showTootip) return;

    const handleClickOutside = (event: MouseEvent) => {
      if (
        tooltipRef.current &&
        !tooltipRef.current.contains(event.target as Node)
      ) {
        setShowTootip(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showTootip]);
  return (
    <s.Div>
      <s.Title>🔎기본 정보 요약</s.Title>
      <s.Table>
        <s.TableHeader>
          <s.Header width="160px">항목</s.Header>
          <s.Header width="calc(100% - 160px)">금액</s.Header>
        </s.TableHeader>
        <s.Row>
          <RowLeft>감정가</RowLeft>
          <RowRight>
            {data?.appraisalPrc ? data?.appraisalPrc.toLocaleString() : '-'} 원
          </RowRight>
        </s.Row>
        <s.Row>
          <RowLeft>최저 입찰가</RowLeft>
          <RowRight>
            {data?.minPrc ? data?.minPrc.toLocaleString() : '-'} 원
          </RowRight>
        </s.Row>
        <s.Row>
          <RowLeft>
            예상 낙찰가
            <img
              src="/assets/images/icon/help.svg"
              alt="?"
              onClick={() => setShowTootip(true)}
            />
            {showTootip && (
              <ToolTip ref={tooltipRef}>
                <TooltipTitle>예상 낙찰가</TooltipTitle>
                <TooltipDescription>
                  과거와 실시간 데이터를 기반으로 시세, 감정가 대비 낙찰가율을
                  분석하고 경매 회차별 하락편차를 고려해 도출한
                  예상낙찰가입니다.
                </TooltipDescription>
              </ToolTip>
            )}
          </RowLeft>
          <RowRight>
            {data?.bidPrc ? data?.bidPrc.toLocaleString() : '-'} 원
          </RowRight>
        </s.Row>
        <s.Row>
          <RowLeft>AI 추정시세</RowLeft>
          <RowRight>
            {data?.aiPrc ? data?.aiPrc.toLocaleString() : '-'} 원
          </RowRight>
        </s.Row>
      </s.Table>
      <s.BottomDescription>
        <div>
          이 물건은{' '}
          {data?.appraisalPrc && data?.bidPrc
            ? '감정가보다 ' +
              (data.appraisalPrc > data.bidPrc ? '낮게' : '높게') +
              ' 낙찰이 예상되며,'
            : ''}
          {data?.appraisalPrc && data?.bidPrc && <br />}
          {data?.aiPrc && data.bidPrc ? (
            <span>
              시세 대비{' '}
              <span style={{ color: '#008AFF' }}>
                {data.aiPrc > data.bidPrc ? '▼' : '▲'} 약{' '}
                {data.aiPrc > data.bidPrc
                  ? Math.floor((1 - data.bidPrc / data.aiPrc) * 100)
                  : Math.floor((1 - data.aiPrc / data.bidPrc) * 100)}
                % {data.aiPrc > data.bidPrc ? '저렴' : '비싸'}
              </span>
              {data.aiPrc > data.bidPrc ? '하게' : '게'} 매입 가능성이 있습니다.
            </span>
          ) : (
            ''
          )}
          {data?.minPrc > data?.bidPrc ? (
            <div style={{ wordBreak: 'keep-all', marginTop: '6px' }}>
              해당 물건은 AI 분석 결과, 예상 낙찰가가 최저 입찰가보다 낮게
              분석됩니다.
              <br />
              <span>
                금번 회차보다{' '}
                <span style={{ color: '#008AFF' }}>
                  다음 회차에서 입찰을 추천
                </span>
                합니다.
              </span>
            </div>
          ) : (
            ''
          )}
        </div>
      </s.BottomDescription>
    </s.Div>
  );
};

export default BasicInformation;

const RowLeft = styled.div`
  position: relative;
  width: 160px;
  padding: 16px;
  height: 100%;
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  justify-content: start;
  font-size: 14px;
  font-weight: 500;
  color: #222222;
`;

const RowRight = styled.div`
  width: calc(100% - 160px);
  padding: 16px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: end;
  font-size: 14px;
  font-weight: 500;
  color: #222222;
`;

const ToolTip = styled.div`
  width: 296px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px;
  border-radius: 12px;
  position: absolute;
  top: 45px;
  left: 20px;
  z-index: 10;
  background-color: #ffffff;
  box-shadow: 1px 2px 20px 0px #00000021;

  &::after {
    content: '';
    position: absolute;
    top: -8px;
    left: 16px;
    border-width: 0 8px 8px 8px;
    border-style: solid;
    border-color: transparent transparent #fff transparent;
    filter: drop-shadow(0px -1px 2px rgba(0, 0, 0, 0.05));
  }
`;

const TooltipTitle = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
`;

const TooltipDescription = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #616161;
`;
